import { signOutUser } from '../slices/AuthSlice';
import { useAppDispatch } from '../slices/store';

export const useLogout = () => {
  const dispatch = useAppDispatch();

  return async () => {
    await dispatch(signOutUser());
  };
};
